var map = {
	"./aws.svg": 101,
	"./c.svg": 102,
	"./css.svg": 103,
	"./dynamodb.svg": 104,
	"./go.svg": 105,
	"./graphql.svg": 106,
	"./html.svg": 107,
	"./ionic.svg": 108,
	"./javascript.svg": 109,
	"./mongodb.svg": 110,
	"./nodejs.svg": 111,
	"./python.svg": 112,
	"./react.svg": 113,
	"./sql.svg": 114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 100;